import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMore = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(2.47, 8.19)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.2504 3.62089C12.7331 3.62089 12.2934 3.44847 11.9313 3.10362C11.5865 2.74153 11.4141 2.31047 11.4141 1.81045C11.4141 1.31042 11.5865 0.887981 11.9313 0.543134C12.2934 0.181045 12.7331 0 13.2504 0C13.7504 0 14.1728 0.181045 14.5177 0.543134C14.8798 0.887981 15.0608 1.31042 15.0608 1.81045C15.0608 2.31047 14.8798 2.74153 14.5177 3.10362C14.1728 3.44847 13.7504 3.62089 13.2504 3.62089Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.54334 3.62089C7.02607 3.62089 6.58639 3.44847 6.2243 3.10362C5.87946 2.74153 5.70703 2.31047 5.70703 1.81045C5.70703 1.31042 5.87946 0.887981 6.2243 0.543134C6.58639 0.181045 7.02607 0 7.54334 0C8.04337 0 8.4658 0.181045 8.81065 0.543134C9.17274 0.887981 9.35379 1.31042 9.35379 1.81045C9.35379 2.31047 9.17274 2.74153 8.81065 3.10362C8.4658 3.44847 8.04337 3.62089 7.54334 3.62089Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.83631 3.62089C1.31904 3.62089 0.879359 3.44847 0.51727 3.10362C0.172423 2.74153 0 2.31047 0 1.81045C0 1.31042 0.172423 0.887981 0.51727 0.543134C0.879359 0.181045 1.31904 0 1.83631 0C2.33634 0 2.75877 0.181045 3.10362 0.543134C3.46571 0.887981 3.64675 1.31042 3.64675 1.81045C3.64675 2.31047 3.46571 2.74153 3.10362 3.10362C2.75877 3.44847 2.33634 3.62089 1.83631 3.62089Z",
					fill: "currentColor"
				})
			]
		})
	});
};
export default SvgMore;
